import { useState } from "react";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LegalModal } from "@/components/landing/Legal";

const CONSENT_KEY = "cs_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(
    () => !localStorage.getItem(CONSENT_KEY)
  );

  const decide = (accepted) => {
    localStorage.setItem(CONSENT_KEY, accepted ? "accepted" : "rejected");
    try {
      if (window.posthog) {
        if (accepted && typeof window.posthog.opt_in_capturing === "function") {
          window.posthog.opt_in_capturing();
        } else if (!accepted && typeof window.posthog.opt_out_capturing === "function") {
          window.posthog.opt_out_capturing();
        }
      }
    } catch (e) {
      // La analítica nunca debe romper la experiencia
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Aviso de cookies"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-[#E4E9F2] bg-white/95 shadow-[0_-12px_40px_-16px_rgba(11,31,58,0.25)] backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 px-4 py-5 sm:px-6 md:flex-row md:items-center lg:px-8">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-navy/[0.06]">
            <Cookie className="h-5 w-5 text-navy" strokeWidth={1.8} />
          </span>
          <p className="text-sm leading-relaxed text-steel">
            Utilizamos cookies técnicas y, con tu consentimiento, cookies de análisis
            para mejorar la web y medir conversiones. Puedes aceptarlas o rechazarlas.
            Más información en nuestra{" "}
            <LegalModal
              type="cookies"
              testId="cookie-policy-link"
              trigger={
                <button
                  type="button"
                  className="font-semibold text-navy underline decoration-navy/30 underline-offset-2 hover:decoration-navy"
                >
                  política de cookies
                </button>
              }
            />
            .
          </p>
        </div>
        <div className="flex w-full shrink-0 gap-2.5 md:w-auto">
          <Button
            data-testid="cookie-reject-button"
            variant="outline"
            className="flex-1 rounded-lg border-navy/20 px-5 font-semibold text-navy hover:bg-platinum md:flex-none"
            onClick={() => decide(false)}
          >
            Rechazar
          </Button>
          <Button
            data-testid="cookie-accept-button"
            className="flex-1 rounded-lg bg-navy px-5 font-semibold text-white hover:bg-navy-light md:flex-none"
            onClick={() => decide(true)}
          >
            Aceptar cookies
          </Button>
        </div>
      </div>
    </div>
  );
}
